module.exports = __webpack_public_path__ + "26d70b5254dd8a462e32a3df2aa44c3d.MP3";